/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionMetadataTool {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionMetadataTool.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionMetadataTool>): AppSecopsSbomVersionMetadataTool {
        let obj = Object.assign(new AppSecopsSbomVersionMetadataTool(), model);
        AppSecopsSbomVersionMetadataTool.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionMetadataTool>): AppSecopsSbomVersionMetadataTool {
        if (!model) return null;
        return AppSecopsSbomVersionMetadataTool.newInstance(<AppSecopsSbomVersionMetadataTool> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionMetadataTool) {
        if (!obj) return;

        models.AppSecopsSbomVersionMetadataTool.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionMetadataTool): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionMetadataTool.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the SBOM tool
     */
    name: string;

    /**
     * Version of the SBOM tool
     */
    version: string;

    /**
     * Sbom component type
     */
    tool_type: models.AppSecopsSbomComponentType;

    /**
     * The person or organization that authored the component tool
     */
    author: string;

}
